import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'
import {getRefunds} from "@/store/refund-summary/action";
import {refundDetailActions} from "@/store/refund-detail/slice";

export const getRefundDetail = createAsyncThunk('refund/getRefundDetail',
  async (id: string) => {
    const url = `v1/refunds/${id}`
    const response: AxiosResponse<Refund> = await instance.get(url)
    return response.data
  })

export const createRefund = createAsyncThunk('refund/createRefund',
  async (payload: any, { dispatch }) => {
    const response: AxiosResponse<Refund> = await instance.post('v1/refunds', payload)
    dispatch(getRefunds({ size: 10 }))
    dispatch(refundDetailActions.showRefundDetailModal({
      show: false,
      id: null
    }))
    return response.data
  })

export const updateRefund = createAsyncThunk('refund/updateRefund',
  async (payload: any, { dispatch }) => {
    const response: AxiosResponse<Refund> = await instance.put(`v1/refunds/${payload.id}`, payload)
    dispatch(getRefunds({ size: 10 }))
    dispatch(refundDetailActions.showRefundDetailModal({
      show: false,
      id: null
    }))
    return response.data
  })

export const sendWhatsapp = createAsyncThunk('refund/sendWhatsapp',
  async (id: string, { dispatch }) => {
    const response: AxiosResponse<Refund> = await instance.post(`v1/refunds/${id}/send-notification`)
    dispatch(getRefundDetail(id))
    return response.data
  })
